<!--<fieldset [formGroup]="form">-->
<!--    <legend>{{ legend }}</legend>-->

<!--    <mat-form-field *ngIf="SearchAddressOptions?.length > 0">-->
<!--&lt;!&ndash;        <app-select-search placeholder="Adressen durchsuchen" &ndash;&gt;-->
<!--&lt;!&ndash;                           (blur)="onTouched()" &ndash;&gt;-->
<!--&lt;!&ndash;                           (selectionChange)="selectionChange($event)"&ndash;&gt;-->
<!--&lt;!&ndash;                           [Options]="SearchAddressOptions" &ndash;&gt;-->
<!--&lt;!&ndash;                           [CompareOptions]="compareOptions"&ndash;&gt;-->
<!--&lt;!&ndash;                           [SearchFunction]="searchFunction"></app-select-search>&ndash;&gt;-->

<!--       -->
<!--    </mat-form-field>-->
<mat-form-field>

    <app-select-search-paged-options
        #pagedSelect
        placeholder="Adressen durchsuchen"
        (blur)="onTouched()"
        [Options]="addressOptions$ | async"
        [isLoading]="addressLoading$ | async"
        [CompareOptions]="compareOptions"
        (opened)="serverSearch('')"
        (searchChange)="serverSearch($event)"
        (selectionChange)="selectionChange($event)"
    >

        <mat-paginator
            option-list-footer
            [pageSize]="50"
            [length]="(addressPageCount$ | async) * 50"
            [pageIndex]="addressPageIndex$ | async"
            (page)="addressPageChange($event)">
        </mat-paginator>

    </app-select-search-paged-options>

</mat-form-field>

    <mat-form-field>
        <input matInput placeholder="Straße" [formControl]="form.controls.Street" (blur)="onTouched()" />
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="Postleitzahl" [formControl]="form.controls.PostalCode" (blur)="onTouched()" />
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="Ort" [formControl]="form.controls.City" (blur)="onTouched()" />
    </mat-form-field>

    <mat-form-field>
        <input matInput placeholder="Land" [formControl]="form.controls.Country" (blur)="onTouched()" />
    </mat-form-field>
<!--</fieldset>-->
